// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['scheduling', 'details', 'enableScheduling', 'enableSchedulingForm']

  initialize() {
    //this.displaySchedule()
  }

  toggleScheduling(e) {
    if(!e.target.classList.contains('click-through') && !['svg', 'path'].includes(e.target.tagName)) {
      this.detailsTarget.classList.toggle("hidden");
    }
  }

  toggleEnabled() {
    if(this.enableSchedulingTarget.checked) {
      this.schedulingTarget.classList.remove("opacity-60")
    } else {
      this.schedulingTarget.classList.add("opacity-60")
    }
    this.enableSchedulingFormTarget.requestSubmit();
  }

  displaySchedule() {
    if (this.sendTarget.checked) {
      this.scheduleTarget.classList.remove("overlay")
    } else {
      this.scheduleTarget.classList.add("overlay")
    }
  }

  displayScheduleDay() {
    if (this.intervalTarget.value == "monthly") {
      this.dayTarget.classList.remove("d-none")
    } else {
      this.dayTarget.classList.add("d-none")
    }
  }

}
